import { render } from "./WindowPopupLayout.vue?vue&type=template&id=0cd17583"
import script from "./WindowPopupLayout.vue?vue&type=script&lang=js"
export * from "./WindowPopupLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__